export const SEARCHBAR_PLACEHOLDER_PREFIX = 'Rechercher des';
